import QRCode from 'qrcode.react';
import styled from 'styled-components';

export const OrderInformationOtherWrapper = styled.div`
  width: 100%;
  height: auto;
  background: none;
`;

export const CQRCode = styled(QRCode)`
  width: 92px !important;
  height: 92px !important;
`;
